import lodashUniqBy from 'lodash/fp/uniqBy';
import lodashOmit from 'lodash/fp/omit';

import {
  SR_API_ACTION_GET_LISTING_LIST,
} from 'api/actionTypes';

export default async function getList({ state, apiClient }) {
  const listingsStateCursor = state.select(['listings']);
  const {
    count,
    page,
    isFullyLoaded,
    enableAllListings,
  } = listingsStateCursor.get();

  const isMapMode = state.get(['listingsViewMode']) === 'map';
  const mapArea = state.get(['listingsMapView', 'mapArea']);
  const area = state.get(['currentUser', 'searchFilters', 'area']);
  const currentUserMarket = state.get(['markets', 'currentUserMarket']);

  if (isFullyLoaded && !isMapMode) {
    return;
  }

  const params = {
    page: page,
    count: count,
    filters: {
      ...state.get(['currentUser', 'searchFilters']),
      locationPoint: area ? [...area, area[0]] : undefined,
    },
    sort: [],
  };

  if (state.get(['currentUser', 'sessionCount']) === 1) {
    params.sort.push(['pinned', 'desc']);
  }

  if (isMapMode) {
    params.page = 0;
    params.count = 96;
  }

  if (enableAllListings && !isMapMode) {
    params.filters.locationPoint = state.get([
      'markets',
      'currentUserMarket',
      'serviceZone',
      'coordinates',
    ]);
  }
  else if (mapArea) {
    params.filters.locationPoint = mapArea;
    delete params.filters.marketId;
  }

  const searchFiltersDisabled = (currentUserMarket.settings.searchFilters || {}).disabled || [];
  params.filters = lodashOmit(searchFiltersDisabled, params.filters);

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_LIST,
    state: state,
    payload: params,
    queryId: state.get(['listingsViewMode']),
    onSuccess({ data, total }) {
      const records = isMapMode
        ? data
        : lodashUniqBy('id', [ ...listingsStateCursor.get('records'), ...data ]);

      listingsStateCursor.set('records', records);
      listingsStateCursor.set('isFullyLoaded', data.length < count);
      listingsStateCursor.set('total', total);
      listingsStateCursor.set('page', isMapMode ? (data.length % count) : (page + 1));
      listingsStateCursor.set('source', isMapMode ? 'map' : 'list');

      if (isMapMode) {
        listingsStateCursor.set('viewMoreIndex', null);
        listingsStateCursor.set('enableAllListings', false);
      }
    },
    onError() {
      listingsStateCursor.set('isFullyLoaded', false);
    },
  });
}
